import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxButtonModule, DxCheckBoxModule, DxTextBoxModule, DxValidationGroupModule, DxValidatorModule, DxMultiViewModule, DxTemplateModule } from 'devextreme-angular';
import { LoginFormRoutingModule } from './login-form-routing.module';
import { LoginFormComponent } from './login-form.component';
import { SingleCardModule } from '../../../layouts/single-card/single-card.component';

@NgModule({
    imports: [
        CommonModule,
        LoginFormRoutingModule,
        DxButtonModule,
        DxCheckBoxModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxValidationGroupModule,
        DxMultiViewModule,
        DxTemplateModule,
        SingleCardModule
    ],
    declarations: [LoginFormComponent],
    exports: [LoginFormComponent]
})
export class LoginFormModule { }
